import {TFunction} from 'i18next'
import {OffsetPagination, PageQuery, PageResult} from "@tracabois/utils";
import {Ouvrage} from "../../../ouvrage";
import {PlatformActions, PlatformPaginatedTable, TableCellText} from "@tracabois/template";
import {CellProps, Column, Row} from '@komune-io/g2-layout'

interface RealizationOuvrageTableProps {
  page: PageResult<Ouvrage>
  isLoading?: boolean
  onPageQueryChange: (page: PageQuery) => void;
  onRowClicked: (row: Row<Ouvrage>) => void;
  actions?: React.ReactNode
}

export const RealizationOuvrageTable = (props: RealizationOuvrageTableProps) => {
  const {page, isLoading, onPageQueryChange, onRowClicked, actions} = props
  const filter = (
    actions && <PlatformActions actions={actions} />
  )
  const onPaginationChange = (pagination: OffsetPagination) => {
    onPageQueryChange({
      pagination: pagination,
      search: page?.search
    })
  }

  return (
    <PlatformPaginatedTable<Ouvrage>
      page={page}
      columnsDefinition={getColumns}
      isLoading={isLoading}
      actions={filter}
      onPageChange={onPaginationChange}
      onRowClicked={onRowClicked}
    />
  )
}


const getColumns = (t: TFunction): Column<Ouvrage>[] => ([{
  Header: `${t("ouvrage.label", "Label")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<Ouvrage>) => (
    <TableCellText main={row.original.ouvrageType?.name || ""}/>
  )
}, {
  Header: `${t("ouvrage.name", "Nom")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<Ouvrage>) => (
    <TableCellText main={row.original.name}/>
  )
}, {
  Header: `${t("ouvrage.species", "Essence")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<Ouvrage>) => (
    <TableCellText main={woodList(row.original)}/>
  )
}, {
  Header: `${t("ouvrage.location", "Localisation")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<Ouvrage>) => (
    <TableCellText main={getLocation(row.original)}/>
  )
}])

const woodList = (ouvrage: Ouvrage): string => {
  return ouvrage.species.map((it) => it.name).join(", ")
}

const getLocation = (ouvrage: Ouvrage): string => {
  // Get unique locations from removal zones
  const locations = ouvrage.removalZones
    ?.map((zone) => {
      const parts = [zone.city?.name, zone.department?.name].filter(Boolean)
      return parts.join(", ")
    })
    .filter(Boolean) || []
  const uniqueLocations = Array.from(new Set(locations))
  return uniqueLocations.join(" | ") || "-"
}
